var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C7.98246 20 5 17.0175 5 13C5 8.98246 7.98246 6 12 6C16.0175 6 19 8.98246 19 13C19 17.0175 16.0175 20 12 20ZM12 22C17 22 21 18 21 13C21 8 17 4 12 4C7 4 3 8 3 13C3 18 7 22 12 22ZM15 1H9C8.45614 1 8 1.45614 8 2C8 2.54386 8.45614 3 9 3H15C15.5439 3 16 2.54386 16 2C16 1.45614 15.5439 1 15 1ZM11 9V13C11 13.5439 11.4561 14 12 14C12.5439 14 13 13.5439 13 13V9C13 8.45614 12.5439 8 12 8C11.4561 8 11 8.45614 11 9Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerOutlined);
export default __webpack_public_path__ + "static/media/timer_outlined.fe544311.svg";
export { ForwardRef as ReactComponent };